/*
 * @Author: hzk
 * @Date: 2021-01-18 16:15:11
 * @LastEditors: hzk
 * @LastEditTime: 2021-01-18 16:57:11
 */
import BankAccount from './bank-account.vue';

export default BankAccount;